import React from 'react';

function InfoBoxHeader (props) {
	return (
		<div></div>
	);
}

export default InfoBoxHeader;